require('./enterNoteDialog.less');


class EnterNoteController {
    activeLine;
    activeMonth;
    comment;
    historicNotes;
    activeYear;

    constructor(private $mdDialog, private Prognosis, private toastService){
    }

    $onInit(){
        this.comment = this.activeLine.forecastLine.months[this.activeMonth-1].note;
    };

    getHistoricNotes () {
        if(this.historicNotes && this.historicNotes !== null && this.historicNotes.length > 0) {
            this.historicNotes = [];
            return;
        }
        this.Prognosis.getNote({articleNo: this.activeLine.articleNo, forecastTypeId: this.activeLine.id, month: this.activeMonth, year: this.activeYear}).$promise.then(
            (result) => {
                if(result && result.length > 0){
                    this.historicNotes = result;
                }else {
                    this.toastService.showSimpleToast("Ingen tilgjengelig historikk", 3000);
                }
            },
            (error) => this.toastService.parseError(error)
        );
    };

    save (){
        this.Prognosis.postNote({articleNo: this.activeLine.articleNo, note: this.comment, forecastTypeId: this.activeLine.id, month: this.activeMonth, year: this.activeYear}).$promise.then(
            () => {
                this.activeLine.forecastLine.months[this.activeMonth-1].note = this.comment;
                this.hide()
            },
            (error) => this.toastService.parseError(error)
        );
    };

    hide () {
        this.$mdDialog.hide();
    };
    cancel () {
        this.$mdDialog.cancel();
    };

}


class EnterNoteOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "enterNoteDialogController";
    public template: any = require('./enterNoteDialog.html');
    bindings: any = {
        activeLine:'=',
        activeMonth:'=',
        activeYear:'='
    };

}


rkcApp.controller("enterNoteDialogController", ['$mdDialog', 'Prognosis', 'toastService', function ($mdDialog, Prognosis, toastService) {
    return new EnterNoteController($mdDialog, Prognosis, toastService);
}])
    .component("enterNoteDialog", new EnterNoteOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/prognosis/enterNoteDialog/enterNoteDialog.ts
 **/